/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from '../quote-cta-component/react-component-lib';

import type { JSX } from '@bhtravel/chat-web-component';

import { applyPolyfills, defineCustomElements } from '@bhtravel/chat-web-component/loader';

applyPolyfills().then(() => defineCustomElements());
export const ChatBhtpFormComponent = /*@__PURE__*/createReactComponent<JSX.ChatBhtpFormComponent, HTMLChatBhtpFormComponentElement>('chat-bhtp-form-component');
export const ChatBhtpContainerComponent = /*@__PURE__*/createReactComponent<JSX.ChatBhtpContainerComponent, HTMLChatBhtpContainerComponentElement>('chat-bhtp-container-component');
